<template>
    <div class="style-v2">
        <div class="progress">
            <nav id="js-steps">
                <router-link v-for="(step, key) in steps" :to="step.to" :key="step.key" :class="{ active: step.completed }">
                    <span>{{ key + 1 }}</span
                    >{{ step.title }}</router-link
                >
            </nav>
            <div class="progress-bar" id="js-progress-bar">
                <div class="progress-bar-fill" :style="'width:' + fill_bar + '%'"></div>
            </div>
        </div>
        <div class="view-cart text-center">
            <router-link to="/cart"
                ><small><i class="fa-duotone fa-cart-shopping"></i> View Cart</small></router-link
            >
        </div>
        <router-view :account="account"></router-view>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            fill_bar: 0,
            account: null,
            steps: [
                {
                    name: "ad-type",
                    to: "/",
                    title: "Ad Type",
                    completed: true,
                },
                {
                    name: "add-ons",
                    to: "/add-ons",
                    title: "Add-Ons",
                    completed: false,
                },
                {
                    name: "builder",
                    to: "/builder",
                    title: "Builder",
                    completed: false,
                },
                {
                    name: "cart",
                    to: "/cart",
                    title: "Cart",
                    completed: false,
                },
                {
                    name: "billing",
                    to: "/billing",
                    title: "Billing",
                    completed: false,
                },
                {
                    name: "payment",
                    to: "/payment",
                    title: "Payment",
                    completed: false,
                },
                {
                    name: "confirmation",
                    to: "/confirmation",
                    title: "Confirmation",
                    completed: false,
                },
            ],
        };
    },
    mounted() {
        this.emitter.on("updateProgress", (data) => {
            this.updateProgress(data);
            this.updateFillBar(data);
        });

        this.getAccount();
    },
    methods: {
        updateProgress(data) {
            this.steps.forEach((step, index) => {
                step.completed = false;

                if (index < data.step) {
                    step.completed = true;
                }
            });
        },
        updateFillBar(data) {
            const items = document.getElementById("js-steps").getElementsByTagName("a");
            const progress_bar = document.getElementById("js-progress-bar");
            for (let i = 0; i < items.length; i++) {
                if (i < data.step) {
                    this.fill_bar =
                        ((items[i].offsetLeft - items[0].offsetLeft + items[i].offsetWidth / 2) / progress_bar.offsetWidth) * 100;
                }
            }

            if (data.step == 7) {
                this.fill_bar =
                    ((items[items.length - 1].offsetLeft - items[0].offsetLeft + items[items.length - 1].offsetWidth) /
                        progress_bar.offsetWidth) *
                    100;
            }
        },
        getAccount() {
            const vue = this;
            axios.get(ibj_people_api_url + "api/accounts/ibj").then((response) => {
                vue.account = response.data.account;
            });
        },
    },
};
</script>
